import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import * as HMS from "../../../common/component/Index";
import { FlagIcons } from '../../../common/component/TranslateButton';
import VinWonder from './../../../../../models/VinWonder';
import { withTranslation } from "react-i18next";
import moment from 'moment';
import { Icon, Menu } from 'antd';
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import DEFINE, { DATE_TIME_FORMAT, TRANSLATE_LANGUAGE, PATHS } from "../../../../../constants/Define";
import * as ANT from 'antd';
import { find, toArray } from 'lodash';
import { siteCodes } from '../../../../../models/VinWonder';
import EllipsisText from '../../../common/component/EllipsisText';
import i18n from "../../../../../constants/initLng";

let permisionActions = [];
const ListCols = ['id', 'name', 'siteCode', 'type', 'typeName', 'vinWonderCode', 'saleStartDate', 'saleEndDate', 'isAvailable', 'blackOutStartDate', 'blackOutEndDate', 'blackOutReason', 'order', 'translations'];

const ModelFields = Object.getOwnPropertyNames(new VinWonder());
class VinWonderList extends Component {
    state = {
        titleTable: Func.getTitleTable(ListCols, ['action'], ['id', 'typeName']),
        modelVinWonder: ModelFields,
        componentTable: {
            name: {
                key: 'name',
                width: 300,
                fixed: 'left',
                sorter: (i, k) => i.name.length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            siteCode: {
                key: 'siteCode',
                render: (text, record) => {
                    let siteCode = '';
                    if(this.props.vinWonderSites){
                        siteCode = this.props.vinWonderSites.find(item => item.code === text);
                    }
                    // else{
                    //     siteCode = siteCodes.find(item => item.id === parseInt(text))
                    // }
                    return siteCode && siteCode.name
                }
            },
            type: {
                key: 'type',
                render: (text, record) => {
                    return record.typeName;
                }
            },
            isAvailable: {
                title: this.props.t('item.vinWonder.available'),
                key: 'isAvailable',
                render: (status) => <HMS.StatusComponent color={status ? 'green' : 'red'}
                    label={status ? i18n.t('item.vinWonder.isAvailable') : i18n.t('item.vinWonder.isUnAvailable')} />,
                filters: [
                    { value: true, text: this.props.t('item.vinWonder.isAvailable') },
                    { value: false, text: this.props.t('item.vinWonder.isUnAvailable') }
                ],
                filterMultiple: false,
            },
            saleStartDate: {
                sorter: (i, k) => i.saleStartDate.length - k.length,
                render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME),
            },
            saleEndDate: {
                sorter: (i, k) => i.saleEndDate.length - k.length,
                render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME),
            },
            blackOutStartDate: {
                // sorter: (i, k) => i.blackOutStartDate.length - k.length,
                render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            blackOutEndDate: {
                // sorter: (i, k) => i.blackOutEndDate.length - k.length,
                render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            order: {
                sorter: (i, k) => i.order.length - k.length,
                render: (text, record) => text
            },
            translations: {
                render: (text, record) => <FlagIcons languages={record.translations} />,
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
            },
            action: {
                width: 90,
                align: 'center',
                fixed: 'right',
                render: (text, record) => this.renderEditComponent(record),
            }
        },
    };

    

    render() {
        const { t, pagination, loading, vinWonders, vinWonderSites } = this.props;
        const { titleTable, modelVinWonder, componentTable } = this.state;
        return (
            <HMS.ListComponent
                tableKey="vin-wonder-list"
                scroll={{ x: 1800 }}
                rowKey={record => record.id}
                loading={{ spinning: loading }}
                dataSource={Func.getDataSource(vinWonders, modelVinWonder)}
                columns={Func.columnsTable({
                    titleTable: titleTable,
                    component: componentTable,
                    itemName: 'vinWonder'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultPageSize: pagination.pageSize, defaultCurrent: pagination.defaultCurrent }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeVinWonder = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.vinWonder.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeVinWonder,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.VIN_WONDER.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }
}

export default withTranslation()(VinWonderList);
